import { toFormData } from "axios";
import server_api from "data/server_apis/server_api";

// Payments

export const createPaymentType = (data) => {
  return server_api.postForm("/payments/payment-type", toFormData(data));
};
export const getPaymentTypes = () => {
  return server_api.get("/payments/payment-type");
};
export const getAllPaymentTypes = () => {
  return server_api.get("/payments/payment-type/get_all");
};
export const getPaymentType = (id) => {
  return server_api.get(`/payments/payment-type/${id}`);
};
export const updatePaymentType = (id, data) => {
  return server_api.patchForm(`/payments/payment-type/${id}`, toFormData(data));
};
export const deletePaymentType = (data) => {
  return server_api.delete(`/payments/payment-type/${data.id}`);
};
export const activatePaymentType = (id) => {
  return server_api.get(`/payments/payment-type/${id}/activate`);
};
// Payment assignment
export const createPaymentAssignment = (data) => {
  return server_api.post("/payments/assign-payments-to-machine", data);
};
export const getPaymentAssignments = () => {
  return server_api.get("/payments/assign-payments-to-machine");
};

export const getPaymentAssignmentForMachineWithPaymentId = (payment,machine) => {
  console.log("Payyyyy : ",payment,machine);
  return server_api.get(`/payments/assign-payments-to-machine/get_assignment?payment=${payment}&machine=${machine}`);
};
export const getAllPaymentAssignments = () => {
  return server_api.get("/payments/assign-payments-to-machine/get_all");
};
export const getPaymentAssignment = (id) => {
  return server_api.get(`/payments/assign-payments-to-machine/${id}`);
};
export const updatePaymentAssignment = (id, data) => {
  return server_api.patch(`/payments/assign-payments-to-machine/${id}`, data);
};
export const deletePaymentAssignment = (data) => {
  return server_api.delete(`/payments/assign-payments-to-machine/${data.id}`);
};
export const activatePaymentAssignment = (id) => {
  return server_api.get(`/payments/assign-payments-to-machine/${id}/activate`);
};

// Machine filter
export const getPaymentsForMachine = (id) => {
  return server_api.get(`/payments/payment-type/in_machine?id=${id}`);
};

// Delete payment for machine
export const deletePaymentsForMachine = (data) => {
  return server_api.post(
    "/payments/assign-payments-to-machine/delete_payment",
    data
  );
};
